export const room = {
  groupName: {
    label: 'Group name',
    create: 'Come up with a group name',
  },
  name: {
    label: 'Name',
    your: 'Your name',
  },
  actions: {
    create: 'Create a room',
    scanCode: 'Scan the room code',
    enter: 'Enter the room',
    start: 'Start with the first room',
  },

  members: 'Group members in the room',

  welcome: {
    part1: 'Welcome {{name}},',
    part2: 'wait until the game starts',
  },

  instructions: {
    read: 'Quietly read the examples on your smartphone',
    ready:
      'When everyone is done, you can enter the room. Explain your example when it appears on the screen.  Speak up in your own words. To go to the next example, click on the navigation buttons at the top of the screen.',
    listen: "Listen to the others. Your groupmates' turn is up.",
    continue: 'We had all the examples. Well done! Proceed with the EDUbox',
  },
  closed: 'The room is closed',
};
